// Copyright (c) 2025 WiseTime. All rights reserved.

import * as TimelineActions from "../../actions"
import { RootState } from "../../../../app/store"
import { groupPostedTimesheetFieldOptionsBySiteId, splitTimeGroupsByPostStatus } from "../../timeGroups"
import { generateTimesheetFieldCachesRefreshActions } from "./generateTimesheetFieldCachesRefreshActions"
import { TimeGroup } from "../../../../generated/wisetime/user/timeline/v4/timeline_pb"

type ProcessTimesheetFieldDataAction = 
  | ReturnType<typeof TimelineActions.generateTimesheetFieldConfigs>
  | ReturnType<typeof TimelineActions.listTimesheetFields>
  | ReturnType<typeof TimelineActions.batchGetTimesheetFieldOptions>

export const processTimesheetFieldData = (
  timeGroups: TimeGroup.AsObject[], 
  state: RootState
): ProcessTimesheetFieldDataAction[] => {
  if (!timeGroups.length) {
    return []
  }
  
  const cachedTimesheetFields = Object.values(state.timeline.timesheetFieldsCache)
  const cachedTimesheetFieldOptions = state.timeline.timesheetFieldOptionsCache
  const cachedTimeGroupFieldConfigs = state.timeline.timeGroupFieldConfigsCache
  const actions: ProcessTimesheetFieldDataAction[] = []
  const { posted, unposted } = splitTimeGroupsByPostStatus(timeGroups)
  const unpostedRequiringConfigs = unposted.filter(timeGroup => (
    !cachedTimeGroupFieldConfigs[timeGroup.id] || cachedTimeGroupFieldConfigs[timeGroup.id]?.length === 0
  ))
  if (unpostedRequiringConfigs.length) {
    actions.push(
      TimelineActions.generateTimesheetFieldConfigs(unpostedRequiringConfigs),
    )
  }
  
  const postedOptionsBySiteId = groupPostedTimesheetFieldOptionsBySiteId(posted)
  const requiredTimesheetFieldActions = generateTimesheetFieldCachesRefreshActions(
    postedOptionsBySiteId,
    cachedTimesheetFields,
    cachedTimesheetFieldOptions,
  )
  actions.push(...requiredTimesheetFieldActions)
  
  return actions
}
